import React, { useRef, useEffect, useState } from "react";
import { Row, Col, Button, Card, OverlayTrigger, Tooltip } from "react-bootstrap";
import Axios from "axios";
import moment from "moment";

//STYLES
import * as ControllerStyles from "../styles/controller";

function Controller() {
    const audioPlayer = useRef(null);
    const clickRef = useRef(null);
    const title = useRef();
    const [titleOverflow, setTitleOverflow] = useState(false);
    const [tracks, setTracks] = useState([]);
    const [currentTrack, setCurrentTrack] = useState(0);
    const [isPlaying, setIsPlaying] = useState(false);

    const [currentTime, setCurrentTime] = useState("00:00");
    const [currentPercentage, setCurrentPercentage] = useState(0);
    const [duration, setDuration] = useState("00:00");

    useEffect(() => {
        loadTracks();
    }, []);

    useEffect(() => {
        // if (audioPlayer.current != null) {
        //     if (isPlaying) {
        //         audioPlayer.current.play();
        //     } else {
        //         audioPlayer.current.pause();
        //     }
        // }
    }, [isPlaying]);

    function loadTracks() {
        Axios.post("/pods/podcastPlayer/loadTracks")
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    setTracks(data.tracks);
                }
            })
            .catch((err) => console.log(err));
    }

    function handleAudioPlay() {
        audioPlayer.current.play();
        setIsPlaying(true);
    }

    function handleAudioPause() {
        audioPlayer.current.pause();
        setIsPlaying(false);
    }

    function forward() {
        let current = currentTrack + 1;
        if (current > tracks.length - 1) {
            current = 0;
        }
        setCurrentTrack(current);
        delayStart(isPlaying);
    }

    function backwards() {
        let current = currentTrack - 1;
        if (current < 0) {
            current = tracks.length - 1;
        }
        setCurrentTrack(current);
        delayStart(isPlaying);
    }

    function handleTrackClickOn(id) {
        setCurrentTrack(id);
        setIsPlaying(true);
        delayStart(true);
    }

    function delayStart(isPlaying) {
        setTimeout(() => {
            if (isPlaying) {
                audioPlayer.current.play();
            }
        }, 10);
    }

    function handleUpdateTime() {
        const formattedCurrentTime = moment.utc(audioPlayer.current.currentTime * 1000).format("mm:ss");
        setCurrentTime(formattedCurrentTime);

        setCurrentPercentage((audioPlayer.current.currentTime / audioPlayer.current.duration) * 100);
    }

    function handleAudioOnLoad() {
        const formattedDuration = moment.utc(audioPlayer.current.duration * 1000).format("mm:ss");
        setDuration(formattedDuration);

        if (title.current.scrollWidth > title.current.offsetWidth) {
            setTitleOverflow(true);
        } else {
            setTitleOverflow(false);
        }
    }

    function handleCheckWith(e) {
        const width = clickRef.current.clientWidth;
        const offset = e.nativeEvent.offsetX;
        const progressPercent = (offset / width) * 100;

        audioPlayer.current.currentTime = (progressPercent / 100) * audioPlayer.current.duration;
    }

    return (
        <div>
            <Row>
                <Col ref={title} style={ControllerStyles.playerTitle}>
                    {titleOverflow ? (
                        <div>
                            <OverlayTrigger
                                placement="bottom"
                                overlay={<Tooltip>Track: {tracks.length !== 0 && tracks[currentTrack].title}</Tooltip>}
                            >
                                <div style={ControllerStyles.playerTitle}>Track: {tracks.length !== 0 && tracks[currentTrack].title}</div>
                            </OverlayTrigger>
                        </div>
                    ) : (
                        <div>Track: {tracks.length !== 0 && tracks[currentTrack].title}</div>
                    )}
                </Col>
            </Row>
            <Row>
                <Col style={ControllerStyles.playerDescription}>
                    Description: <br /> {tracks.length !== 0 && tracks[currentTrack].description}
                </Col>
            </Row>
            <Row>
                <Col style={ControllerStyles.playerScreen}>Screen...</Col>
            </Row>
            <Row>
                <Col style={ControllerStyles.statusBarBackground} ref={clickRef} onClick={handleCheckWith}>
                    <div style={{ ...ControllerStyles.statusBar, width: `${currentPercentage}%` }}></div>
                </Col>
            </Row>
            <Row>
                <Col>{currentTime}</Col>
                <Col style={ControllerStyles.durationTime}>{duration}</Col>
            </Row>
            {tracks.length > 0 ? (
                <div>
                    <Row>
                        <Col style={ControllerStyles.controls}>
                            <Button variant="outline-primary" onClick={backwards}>
                                <i className="fa-solid fa-backward"></i>
                            </Button>
                        </Col>
                        <Col style={ControllerStyles.controls}>
                            {isPlaying ? (
                                <div>
                                    <Button variant="outline-primary" onClick={handleAudioPause}>
                                        <i className="fa-solid fa-pause"></i>
                                    </Button>
                                </div>
                            ) : (
                                <div>
                                    <Button variant="outline-primary" onClick={handleAudioPlay}>
                                        <i className="fa-solid fa-play"></i>
                                    </Button>
                                </div>
                            )}
                        </Col>
                        <Col style={ControllerStyles.controls}>
                            <Button variant="outline-primary" onClick={forward}>
                                <i className="fa-solid fa-forward"></i>
                            </Button>
                        </Col>
                    </Row>
                </div>
            ) : (
                <div>
                    <Row>
                        <Col style={ControllerStyles.noTracksMessage}>No tracks to play!</Col>
                    </Row>
                </div>
            )}
            <Row>
                <Col style={ControllerStyles.playerTrackList}>
                    {tracks.map((track, index) => {
                        return (
                            <div key={index}>
                                <Card style={ControllerStyles.trackCard} onClick={handleTrackClickOn.bind(this, index)}>
                                    <Card.Body>
                                        <Row>
                                            <Col>{track.title}</Col>
                                        </Row>
                                        <Row>
                                            <Col style={ControllerStyles.playerTrackDuration}>{track.duration}</Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                                <br />
                            </div>
                        );
                    })}
                </Col>
            </Row>
            {tracks.length !== 0 && (
                <audio
                    src={`/content/podCasts/${tracks[currentTrack].filename}`}
                    ref={audioPlayer}
                    onTimeUpdate={handleUpdateTime}
                    onLoadedMetadata={handleAudioOnLoad}
                />
            )}
            {/* <h1>Podcasts front end</h1> */}
            {/* <Button onClick={handleAudioPlay}>Play</Button> */}
        </div>
    );
}

export default Controller;
